import React, { Component } from "react";
import PropTypes from "prop-types";
import { compose } from "redux";
import isEqual from "lodash/isEqual";
import classNames from "classnames";
import { Form as FinalForm } from "react-final-form";

import { injectIntl } from "../../../util/reactIntl";
import { ensureCurrentUser } from "../../../util/data";

import { Form, PrimaryButton, H4 } from "../../../components";

import css from "./NotificationPreferencesForm.module.css";
import SMSVerification from "../../../components/SMSVerification/SMSVerification";
import SMSToggle from "../../../components/SMSToggle/SMSToggle";

class NotificationPreferencesFormComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.submittedValues = {};
  }

  render() {
    return (
      <FinalForm
        {...this.props}
        render={(fieldRenderProps) => {
          const {
            rootClassName,
            className,
            currentUser,
            handleSubmit,
            inProgress,
            invalid,
            values,
          } = fieldRenderProps;
          const { smsNotifications } = values;

          const user = ensureCurrentUser(currentUser);

          if (!user.id) {
            return null;
          }

          const { profile } = user.attributes;
          const privateData = profile?.privateData || null;

          const isSMSVerified = privateData?.phoneVerified ?? false;

          // SMS Notifications
          const currentSMSSetting = privateData?.smsNotifications ?? "active";

          const smsChanged = currentSMSSetting !== smsNotifications;

          const classes = classNames(rootClassName || css.root, className);
          const submittedOnce = Object.keys(this.submittedValues).length > 0;
          const pristineSinceLastSubmit =
            submittedOnce && isEqual(values, this.submittedValues);
          const submitDisabled =
            invalid || pristineSinceLastSubmit || inProgress || !smsChanged;

          return (
            <Form
              className={classes}
              onSubmit={(e) => {
                this.submittedValues = values;
                handleSubmit(e);
              }}
            >
              <div className={css.contactDetailsSection}>
                <H4 as="h2" className={css.sectionTitle}>
                  SMS Notifications
                </H4>
                <span>
                  Get notifications about your bookings and chat messages via
                  text messages.
                </span>
                <div className={css.smsNotifications}>
                  {isSMSVerified ? (
                    <SMSToggle
                      label="Turn on/off SMS notifications"
                      id="sms-notifications"
                      svgClassName="sms-toggle"
                      name="smsNotifications"
                    />
                  ) : (
                    <SMSVerification />
                  )}
                </div>
              </div>

              {isSMSVerified && (
                <div className={css.bottomWrapper}>
                  <PrimaryButton
                    type="submit"
                    id={css.saveChangesButton}
                    inProgress={inProgress}
                    ready={pristineSinceLastSubmit}
                    disabled={submitDisabled}
                  >
                    Save Changes
                  </PrimaryButton>
                </div>
              )}
            </Form>
          );
        }}
      />
    );
  }
}

NotificationPreferencesFormComponent.defaultProps = {
  rootClassName: null,
  className: null,
  formId: null,
};

const { string } = PropTypes;

NotificationPreferencesFormComponent.propTypes = {
  rootClassName: string,
  className: string,
  formId: string,
};

const NotificationPreferencesForm = compose(injectIntl)(
  NotificationPreferencesFormComponent
);

NotificationPreferencesForm.displayName = "NotificationPreferencesForm";

export default NotificationPreferencesForm;
